<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<div class="hero-eyebrow" waCaption="s" waFontWeight="semibold" waText>PLUGIN MODEL</div>
				<h2 waHeading="l" waText>Modular, Discoverable, Composable</h2>
				<p waBody="m" waColorText="quiet" waText>Add a Maven dependency. The plugin integrates itself.</p>
			</div>
			<div class="wa-stack wa-gap-m">
				<div class="wa-grid wa-gap-m" style="--min-column-size:20rem;">
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>JPMS Modules</h3>
							<p waBody="m" waColorText="quiet" waText>Every plugin ships a module-info.java with explicit exports, requires, provides, and uses. Clean dependency boundaries. JLink-ready for minimal Docker images.</p>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>SPI Discovery</h3>
							<p waBody="m" waColorText="quiet" waText>Plugins register via ServiceLoader &#40;JPMS provides...with or META-INF/services&#41;. The framework discovers them at startup &mdash; no manual wiring.</p>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Annotation-Driven Integration</h3>
							<p waBody="m" waColorText="quiet" waText>Plugins use the TypeScript Client annotation library &#40;&#64;NgComponent, &#64;NgDirective, etc.&#41; to describe their Angular integration. The build generates all TypeScript code.</p>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Page Configurators</h3>
							<p waBody="m" waColorText="quiet" waText>IPageConfigurator implementations inject CSS, JS, meta tags, and transform the component tree before rendering. Plugins hook in via SPI.</p>
						</div>
					</wa-card>
				</div>
			</div>
		</div>
	</div>
</div>